import { buildApiUrl } from "../../services/apiConfig";

const base = () => buildApiUrl('PIPELINE_PROCESS_TRACKER');

export const fetchDdlcServices = async () => {
  const res = await fetch(`${base()}/services`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.services; // string[]
};

export const fetchDdlcStreams = async (service) => {
  const res = await fetch(`${base()}?service=${encodeURIComponent(service)}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.streams; // [{ type, name }]
};

export const fetchDdlcLatestLogs = async ({
  service,
  level,
  type,
  name,
  limit = 200,
  since_seconds = 604800,
  start_ts,
}) => {
  const params = new URLSearchParams({ service, limit, since_seconds });
  if (level) params.set('level', level);
  if (type)  params.set('type', type);
  if (name)  params.set('name', name);
  if (start_ts) params.set('start_ts', start_ts);
  const res = await fetch(`${base()}/latest?${params}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.entries; // [{ timestamp, level, filename, line }]
};

export const fetchDdlcSearchLogs = async ({
  service,
  search,
  level,
  type,
  name,
  limit = 200,
  since_seconds = 604800,
}) => {
  const params = new URLSearchParams({ service, search, limit, since_seconds });
  if (level) params.set('level', level);
  if (type)  params.set('type', type);
  if (name)  params.set('name', name);
  const res = await fetch(`${base()}/search?${params}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.entries;
};
